/*Recurso: Authenticate - Variables y rutinas store que almacenan la respuesta del API y su manipulación en el front
  Tareas:
    Auth      //usuarios de prueba
    AuthLDAP  //usuarios registrados en ldap
*/
//elementos stores: elementos que llenamos con inf. del api y otros elementos captados del front o para manejo del front
//funciones stores: rutinas que captan o modifican los elementos store
//response: { config: {}, hearders:{}, request:{}, data: { informacion: {}, resultado: {}, contenido: [{ }] } } //esto trae la lectura de api

import create from "zustand";

const authenticateStore = create((set:any, get:any) => ({

  objErrorAuthenticateStore: { hasError: false, url:'', body:'', recurso:'authenticate', componente:'', idresul: 0, desresul:'', menu:''},//se llena con la información del api si éste tiene error

      //*Limpia objeto de error cuando éste ya se mostro en VentanaObjeErrorAPI
      limpiaobjErrorAuthenticateStore: () => {
          let paso = { hasError: false, url:'', body:'', recurso:'authenticate', componente:'', idresul:0, desresul:'', menu:''}
          set( { objErrorAuthenticateStore: paso } );
          //console.log('limpiaobjErrorAuthenticateStore (sale) - objErrorAuthenticateStore: ', get().objErrorAuthenticateStore);
      },

      //*Error en api: entra a esta función cuando el servicio cae en catch y muestra el error en VentanaObjError
      generaobjErrorAuthenticateStore: async (responseAPI:any, h:any, h2:any, b:any, c:any, m:any) => {
          //alert('authenticateStore - generaobjErrorAuthenticateStore:');
          //console.log('****generaobjErrorAuthenticateStore (entra): ', responseAPI);
          //console.log('*generaobjErrorAuthenticateStore (entra): h: ', h , ' h2: ',  h2 , ' b: ', b , ' c: ', c );
          let paso = { hasError: h, url:'', body:b, recurso:'authenticate', componente:c, idresul:0, desresul:'', menu:m }
          
          if (responseAPI==undefined || responseAPI=='Error: Network Error'){
              paso.idresul=-1;
              paso.desresul= 'Error inesperado, asegure su conexión con internet y vpn';
          }
          else {
              paso.url=responseAPI.config.url;
              if (responseAPI.data!=""){
                paso.idresul=responseAPI.data.ret;
                paso.desresul= responseAPI.data.msjerror;
              }    
              else {
                  paso.idresul= responseAPI.status;
                  if (responseAPI.status==404)
                      paso.desresul= "El usuario no existe"//responseAPI.statusText;  
                  else
                      paso.desresul= responseAPI.statusText;  
              }
          }
          set( { objErrorAuthenticateStore: paso } );
          console.log('::authenticateStore - generaobjErrorAuthenticateStore (sale) - objErrorAuthenticateStore: ', get().objErrorAuthenticateStore);
      },

  authStore: [],  //guarda response.data de la tarea: Auth
  usuarioStore: "", //guarda: el usuario captado en frontend
  tokenStore: "", //guarda: "bearer"  + response.data.value (token) para asignar a los api's 
  rolsStore: [],  //extraemos de response.data.rols y generamos el insumo de roles para el menu
  cnnStore:"", //guarda el datos de cnn (que trae el bd ip que ocupo en Acerca del sitio)

      //*Tarea: Auth o AuthLap, guardo el resultado de api en elementos store // se ejecuta al entrar en Autentificar -  botón: Iniciar sesion
      guardaAuthStore: async (responseAPI:any, u:any) => {   
        //alert('authenticate.store - guardaAuthStore' );
        //console.log('guardaAuthStore - responseAPI:', responseAPI)
        //set( { authResponseStore: responseAPI } );
        
        set( { authStore: responseAPI.data } );
        set( { tokenStore: "bearer " + responseAPI.data.value } );
        set( { usuarioStore: u } );
        if ( responseAPI.data.rols.length == 0)
          set( { rolsStore: [0]} );
        else
          set( { rolsStore: get().authStore.rols } );
        let paso = responseAPI.data.cnn[1].valor;
        set( { cnnStore: paso } );
        //console.log ('authResponseStore: ', get().authResponseStore );
        //console.log ('::authStore: ', get().authStore );
        //console.log ('::usuarioStore: ', get().usuarioStore );
        //console.log ('::tokenStore: ', get().tokenStore );
        //console.log ('::rolsStore: ', get().rolsStore );
        console.log ('::cnn: ', get().cnnStore );
      }
  
}));

export default authenticateStore;
